import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { MoreHorizontal } from 'lucide-react';

interface TabsNavigationProps {
  activeTab: string;
  onTabChange: (value: string) => void;
}

export const TabsNavigation: React.FC<TabsNavigationProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="border-b border-border/30 mb-8 overflow-hidden bg-gradient-to-r from-background to-muted/10 rounded-t-xl">
      <TabsList className="bg-transparent h-14 -mb-px overflow-x-auto flex-nowrap scrollbar-hide w-full justify-start px-4 lg:px-6">
        <TabsTrigger 
          value="overview" 
          className="data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none data-[state=active]:bg-primary/5 rounded-t-lg text-sm sm:text-base px-4 lg:px-5 py-3 font-medium transition-all duration-300 hover:bg-muted/30 whitespace-nowrap"
        >
          Overview
        </TabsTrigger>
        <TabsTrigger 
          value="mealplans" 
          className="data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none data-[state=active]:bg-primary/5 rounded-t-lg text-sm sm:text-base px-4 lg:px-5 py-3 font-medium transition-all duration-300 hover:bg-muted/30 whitespace-nowrap"
        >
          <span className="hidden sm:inline">Dietary and Meal Plan Goals</span>
          <span className="sm:hidden">Dietary Goals</span>
        </TabsTrigger>
        <TabsTrigger 
          value="appointments" 
          className="data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none data-[state=active]:bg-primary/5 rounded-t-lg text-sm sm:text-base px-4 lg:px-5 py-3 font-medium transition-all duration-300 hover:bg-muted/30 whitespace-nowrap"
        >
          Appointments
        </TabsTrigger>
        <TabsTrigger 
          value="medical" 
          className="data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none data-[state=active]:bg-primary/5 rounded-t-lg text-sm sm:text-base px-4 lg:px-5 py-3 font-medium transition-all duration-300 hover:bg-muted/30 whitespace-nowrap"
        >
          <span className="hidden sm:inline">Medical History</span>
          <span className="sm:hidden">Medical</span>
        </TabsTrigger>
        
        {/* More dropdown for remaining tabs */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="sm" className="h-14 rounded-t-lg px-4 lg:px-5 py-3 hover:bg-muted/30 hover:text-foreground data-[state=open]:bg-muted/30 text-sm sm:text-base font-medium transition-all duration-300 whitespace-nowrap">
              More <MoreHorizontal className="h-4 w-4 ml-1" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56 shadow-xl border-border/30 z-50">
            <DropdownMenuItem onClick={() => onTabChange('questionnaires')} className="py-3 px-4 text-base font-medium hover:bg-primary/5 transition-colors">
              Questionnaires
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onTabChange('preferences')} className="py-3 px-4 text-base font-medium hover:bg-primary/5 transition-colors">
              Food Preferences
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onTabChange('labReports')} className="py-3 px-4 text-base font-medium hover:bg-primary/5 transition-colors">
              Lab Reports
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </TabsList>
    </div>
  );
};
